import axios from "axios";
import Api from "./api";

export async function statusOnboarding(params = {}) {
  try {
    const { data } = await Api.get("/onboarding/status", { params, timeout: 10000 });
    return data;
  } catch (err) {
    if (err?.response?.status === 401) throw err;
    if (axios.isCancel(err)) throw err;
    return {
      checks: [
        { key: "whatsapp", title: "Conecte seu WhatsApp", description: "", done: false, count: 0, required: 1, cta: { label: "Adicionar WhatsApp", to: "/connections" } },
        { key: "queue", title: "Crie sua primeira fila", description: "", done: false, count: 0, required: 1, cta: { label: "Criar primeira fila", to: "/Queues" } },
        { key: "user", title: "Convide o primeiro atendente", description: "", done: false, count: 0, required: 2, cta: { label: "Criar atendente", to: "/users" } },
        { key: "contact", title: "Seu primeiro contato", description: "", done: false, count: 0, required: 1, cta: { label: "Importar contatos", to: "/contacts" } },
        { key: "ticket", title: "Atenda seu primeiro ticket", description: "", done: false, count: 0, required: 1, cta: { label: "Ir para atendimentos", to: "/tickets" } },
      ],
      progress: 0,
      doneCount: 0,
      totalChecks: 5,
      pendingCount: 5,
      completedAt: null,
      erroFallback: true,
      erroMensagem: err?.message || "Falha ao carregar",
    };
  }
}

export default { statusOnboarding };
